export * from './light-dimmer.component';
